module.exports = __webpack_public_path__ + "img/ditan_xc4.3a3d20c0.jpg";